import React, { useState, useEffect, useParams, useLayoutEffect } from "react";
import { FaTimesCircle } from "react-icons/fa";
import { AiOutlineRight } from "react-icons/ai";
import { FiChevronDown } from "react-icons/fi";
import { useHistory, useLocation } from "react-router-dom";
import "./NewPlancomponent.css";
import { useDispatch, useSelector } from "react-redux";
import plandetail from "./plandetail";
import giftCardImg from "../../Assets/giftcard2.svg";
import {
  AddtoCart,
  getCartDetails,
  setAllPackageAddonTrue,
  setAllPackageAddonFalse,
  getCouponCode,
  setCity,
} from "../../Redux/Actions";
import { FloatingButton } from "../Cart/Cart";
import Loader from "../Loader/Loader";
import { connect } from "react-redux";
import { json, response } from "express";
import Discount from "../../Assets/Discount.svg";
import greenWallet from "../../Assets/wallet_green.svg";
import { Modal } from "react-responsive-modal";
import giftCard from "../../Assets/giftCard.svg";
import metroCross from "../../Assets/metroCross.svg";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { getRedcash } from "../../Redux/Actions";
import "react-responsive-modal/styles.css";
import Axios from "../../config/Axios";
import Prefix from "../../config/ApiPrefix";
import ReactTooltip from "react-tooltip";
import Cart from "../../components/Cart/Cart";

function BookForm(props) {
  //city List
  const navCity = useSelector((state) => state.navCityList);
  const { navCities, navloading } = navCity;

  // const body = window.document.querySelector("body");
  const [state, setState] = useState({
    isPaneOpen: false,
  });

  const [display, setDisplay] = useState(false);

  const handelCity = (city) => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    localStorage.setItem("city", city);
    setSearchCity(city);
    dispatch(setCity(city != "" ? city : ""));
    setDisplay(false);
    // e.target.blur();
    // userProfile && userProfile !== ""
    //   ? dispatch(EmptyCart(userProfile && userProfile.token, successCd))
    //   : null;
  };
  useEffect(
    function mount() {
      function updateSize() {
        console.log("scroll!");
        const body = window.document.querySelector("body");
        if (state.isPaneOpen) {
          body.style.overflow = "hidden";
        } else {
          body.style.overflow = "auto";
        }
      }
      window.addEventListener("class", updateSize);
      return function unMount() {
        window.removeEventListener("class", updateSize);
      };
    },
    [state]
  );

  // useEffect(() => {
  //   if (state.isPaneOpen) {
  //     body.style.overflow = "hidden";
  //   } else {
  //     body.style.overflow = "auto";
  //   }
  // }, [state]);
  const [cashback, setCashback] = useState(0);
  const [isRedcash, setIsRedcash] = useState(false);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [openCartt, setOpenCartt] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const onOpenModal2 = () => setOpen2(true);
  const onCloseModalCartt = () => setOpenCartt(false);

  const onCloseModal2 = () => {
    setOpen2(false);
    setState({ isPaneOpen: false });
  };
  const pathname = location.pathname;

  const imagine = props.imagineCart;

  const packDetail = props.packDetail;
  const {
    packageDetails,
    details,
    handleSubmit,
    selectAddress,
    notavailPack,
    setOpenMDPackage,
  } = props;
  //coupn code data
  const coupnData = useSelector((state) => state.getCouponCodeReducer);

  // console.log(props.AddonState, "ADDON STATES");
  const { coupnCode, loading: couponLoading } = coupnData;

  console.log("coupn code", coupnCode);
  const [showDetails, setShowDetails] = useState(true);
  // console.log("package detail", packageDetails && packageDetails);
  // console.log("from cart handel funtion ", handleSubmit);
  const history = useHistory();
  const [Proceed, setProceed] = useState(false);

  const [coupCode, setCoupCode] = useState("");
  const [coupError, setCoupError] = useState("");

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  const dispatch = useDispatch();
  //GETTING RESPONSE FROM STORE
  const cartStatus = useSelector((state) => state.addToCartReducer);
  const cartLength = useSelector((state) => state.CartReducer);
  // const {loading:cartloading , }
  // console.log("cart status", cartStatus);

  //cart status

  const { loading } = cartStatus;
  const [coupnDis, setcoupnDis] = useState(0);

  // const handleCuponChange = (e) => {
  //   const userFromLocal = JSON.parse(localStorage.getItem("user"));
  //   var token = userFromLocal && userFromLocal.token;
  //   props.getCoupon(token, e.target.value);
  // };

  const Mrp = packageDetails?.package_city_prices?.package_price
    ? packageDetails?.package_city_prices?.package_price
    : packageDetails?.package_price;

  const offerPrice = packageDetails?.package_city_prices?.offer_price
    ? packageDetails?.package_city_prices?.offer_price
    : packageDetails?.offer_price;

  const discount = Mrp - offerPrice;
  var deliveryCharges = 0;
  offerPrice < 99 ? (deliveryCharges = 200) : null;

  const finalPrice = Mrp + deliveryCharges - discount;

  const successCb = () => {
    if (localStorage.getItem("user")) {
      const userFromLocal = JSON.parse(localStorage.getItem("user"));
      var token = userFromLocal.token;
      dispatch(getCartDetails(token, citySelect && citySelect));
    }
  };

  const discountPercentage = Math.ceil((discount / Mrp) * 100);
  const [goto, setGoto] = useState("");
  const [myCash, setMyCash] = useState(null);

  //gatsby
  const addtocart = (packageid, details) => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;

    const body = {
      package: packageid,
    };
    if (token && token !== "") {
      dispatch(AddtoCart(body, token, successCb));
    } else {
      console.log("from details", details);
      history.push({
        pathname: `/login`,
        packageId: packageid,
        pushToUrl: "cart",
      });
      // console.log("PackId in BookForm", packageid);
    }

    localStorage.setItem("packageSlug", packageDetails.slug);
  };
  const handleClickOpenSlider = () => {
    if (!isRedcash) {
      setState({ isPaneOpen: true });
    } else {
      alert("You can either use redcash or apply coupon");
    }
  };
  useEffect(() => {
    dispatch({
      type: "EPMTY_CART_OBJECT",
    });
  }, []);
  useEffect(() => {
    localStorage.setItem("is_redcash_applied", "false");
    localStorage.setItem("giftcard", "");
    if (localStorage.getItem("user")) {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user.token;
      props.getRedcash(token);
    }
  }, []);

  useEffect(() => {
    setMyCash(props?.Redcash?.redcash && props?.Redcash?.redcash[0]);
  }, [props?.Redcash]);

  const [ItemInCart, setItemInCart] = useState([]);
  const [ItemidInCart, setItemidInCart] = useState([]);

  useEffect(() => {
    let newArray = [];
    let newArray1 = [];
    if (props.CartItem && props.CartItem[0] && props.CartItem[0]?.product) {
      props.CartItem[0]?.product.map((item) => {
        newArray.push(item.package);
      });
      props.CartItem[0]?.product.map((item) => {
        newArray1.push(item.package.id);
      });
      setItemInCart(newArray);
      setItemidInCart(newArray1);
    } else {
      setItemInCart([]);
    }
    console.log(ItemInCart, "IIC");
  }, [props?.CartItem]);

  const isAlreayAppliedPromise = (coupon_id) => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    const config = {
      headers: {
        Authorization: `Token ${datekey.token}`,
      },
    };
    return new Promise((resolve, reject) => {
      Axios.get(`${Prefix.api}/coupon/red_validate/${coupon_id}/`, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          alert(JSON.stringify(error.response.data.errors.toString()));
          console.log(error.message);
          // window.alert("A booking is already done with this number for same collection date.")
        });
    });
  };

  if (details !== "") {
    var sum = details.reduce((currentSum, nextObject) => {
      // Note that you need to coerce points_earned
      // to a Number or it will simply concatenate the strings
      return (currentSum += nextObject?.package?.package_city_prices
        ? nextObject?.package?.package_city_prices?.package_price
        : nextObject?.package?.package_price);

      // 0 is your initial value used by currentSum in
      // the first iteration
    }, 0);

    // console.log("this is some", sum);
  }
  if (details !== "") {
    var offerSum = 0;
    let numOfTrue = 0;
    // console.log(details, "Lenght Detail obj")
    details.map((item) => {
      if (item?.package?.is_addon) {
        numOfTrue += 1;
      }
    });

    if (details.length == numOfTrue) {
      console.log("all are add on packages");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        currentOfferSum += nextObject?.package?.package_city_prices
          ? nextObject?.package?.package_city_prices?.offer_price
          : nextObject?.package?.offer_price;
        console.log(
          nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price,
          "Now only offer price"
        );
        return currentOfferSum;
      }, 0);
    } else {
      // props.setAllAddonFalse()
      console.log("all are not add on");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        if (nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.addon_price;
          console.log(
            nextObject?.package?.addon_price,
            " Add on price package found"
          );
        } else if (!nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price;
          console.log(
            nextObject?.package?.package_city_prices
              ? nextObject?.package?.package_city_prices?.offer_price
              : nextObject?.package?.offer_price,
            "Offer price/pack citywise package found"
          );
        }
        return currentOfferSum;
      }, 0);
    }

    if (offerSum < 99) {
      deliveryCharges = 200;
    }
  }
  if (details !== "") {
    var discountSum = sum - offerSum;
    var discountPercent = Math.ceil((discountSum / sum) * 100);
  }

  const [coupnDataClick, setCoupnData] = useState("");
  //NEXT BUTTON PROGRM
  const NextbUTTON = (id, slug, handleSubmit, details) => {
    if (goto && goto !== "") {
      history.push("/cart");
    }
    if (id && id !== "" && citySelect != "") {
      addtocart(id, slug);
    } else if (details && details !== "") {
      localStorage.setItem("coupnCode", JSON.stringify(coupnDataClick));
      if (pathname == "/imaging/cart") {
        history.push({
          pathname: `/imagine-patient-details`,
          state: coupnDis,
        });
      } else {
        if (citySelect == "" || citySelect == null) {
          setOpenCartt(true);
        } else if (notavailPack && notavailPack.length > 0) {
          setOpenMDPackage(true);
        } else {
          history.push({
            pathname: `/ps`,
            state: coupnDis,
          });
        }
      }
    } else {
      setOpenCartt(true);
    }
  };

  const [searchCity, setSearchCity] = useState("");
  const [cartButton, setButton] = useState("Add to cart");
  useEffect(() => {
    if (details !== "" && discountSum) {
      setButton("CHECKOUT");
    } else if (cartStatus && cartStatus.cart !== "") {
      if (cartStatus?.loading == true) {
        // console.log("CART ADD STATUS", cartStatus.loading);
        setButton("Adding");
      } else {
        setButton(" ");
        setGoto("Go to cart");
      }
    } else {
      if (props?.btn == false) {
        setButton("");
      } else {
      }
    }
  }, [cartStatus, cartStatus && cartStatus.loading]);

  useEffect(() => {
    if (details) {
      let numOfTrue = 0;
      console.log(details, "Lenght Detail obj");

      details &&
        details?.map((item) => {
          if (item?.package?.is_addon) {
            numOfTrue += 1;
          }
        });

      if (details.length == numOfTrue) {
        props.setAllAddonTrue();
      } else {
        props.setAllAddonFalse();
      }
    }
  }, [details]);
  // console.log("total" , totalprice , "offerprice" , tota)
  const [active, setActve] = useState("");
  const [isGiftCard, setIsGiftCard] = useState(false);
  const [showCross, setCross] = useState(true);
  const removeCoupn = () => {
    setcoupnDis(0);
    setCashback(0);
    isGiftCard ? setActve("Redcash") : setActve("Giftcard");
  };
  const applyCoupn = (applyCoupn) => {
    setState({ isPaneOpen: false });
    isAlreayAppliedPromise(applyCoupn?.id)
      .then((res) => {
        if (applyCoupn.is_red_cash && res.already_applied) {
          alert(
            "Coupon Already Used:\nThis coupon is only valid once per user"
          );
        } else {
          if (applyCoupn.packages?.length > 0) {
            let specialDis = 0;
            applyCoupn.packages?.map((i) => {
              let item = ItemInCart?.find((x) => x.id == i.id);
              if (item) {
                item?.package_city_prices?.offer_price
                  ? (specialDis += item?.package_city_prices?.offer_price)
                  : item?.package_city_prices?.package_price
                  ? (specialDis += item?.package_city_prices?.package_price)
                  : item?.offer_price
                  ? (specialDis += item?.offer_price)
                  : (specialDis += item?.package_price);
              }
            });
            if (applyCoupn.discount_type == "percentage") {
              setcoupnDis(Math.floor((specialDis * applyCoupn.discount) / 100));
            } else {
              setcoupnDis(Math.min(applyCoupn.discount, specialDis));
            }
            console.log(specialDis, "specialDis");
          } else if (applyCoupn.name == "HEALTH") {
            setcoupnDis(Math.floor(((offerSum + deliveryCharges) * 25) / 100));
            setCashback(Math.floor(offerSum + deliveryCharges));
          } else if (applyCoupn.is_red_cash) {
            setcoupnDis(0);
            if (applyCoupn.discount_type == "percentage") {
              setCashback(
                Math.floor(
                  ((offerSum + deliveryCharges) * applyCoupn.discount) / 100
                )
              );
            } else {
              setCashback(applyCoupn.discount);
            }
          } else {
            if (applyCoupn.discount_type == "percentage") {
              setcoupnDis(
                Math.floor(
                  ((offerSum + deliveryCharges) * applyCoupn.discount) / 100
                )
              );
            } else {
              setcoupnDis(applyCoupn.discount);
            }
            setCashback(0);
          }
          setCoupnData(applyCoupn);
          setActve(applyCoupn.name);
          localStorage.setItem("giftcard", "");
          setCoupError("");
          // onCloseModal();
          onOpenModal2();
          // setTimeout(() => {
          //   onCloseModal2();
          // }, 2000);
          if (active == applyCoupn.name) {
          } else {
          }
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
  const handleCoupCode = (e) => {
    setCoupCode(e.target.value);
  };
  const handleApplyCoupon = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;
    props.getCoupon(token, coupCode);
    // if (coupnCode?.results?.some((val) => val.name.toLowerCase() == coupCode.toLowerCase())) {
    //   applyCoupn(coupnCode?.results?.find((val) => val.name.toLowerCase() === coupCode.toLowerCase()));
    // } else {
    //   setCoupError("Invalid Coupon Code");
    // }
  };

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;
    if (state?.isPaneOpen) {
      props.getCoupon(token, "");
      setCoupCode("");
    }
  }, [state]);
  const checkGiftcardPromise = () => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    const config = {
      headers: {
        Authorization: `Token ${datekey.token}`,
      },
    };
    return new Promise((resolve, reject) => {
      Axios.get(
        `${Prefix.api}/coupon/gift_card/?code=${giftcardCoupon}`,
        config
      )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          alert(JSON.stringify(error.response.data.errors.toString()));
          // window.alert("A booking is already done with this number for same collection date.")
        });
    });
  };
  const handleApplyGiftcard = async () => {
    if (!isGiftCard) {
      removeCoupn();
      const response = await checkGiftcardPromise();
      if (response?.results[0]?.is_active) {
        setIsGiftCard(true);
        setcoupnDis(
          Math.min(
            Math.floor(offerSum + deliveryCharges),
            response?.results[0]?.amount
          )
        );
        if (response?.results[0]?.amount >= offerSum + deliveryCharges) {
          localStorage.setItem("zeroprice", "true");
        } else {
          localStorage.setItem("zeroprice", "false");
        }
        console.log("here", response?.results[0]?.amount, coupnDis);
        localStorage.setItem("giftcard", response?.results[0]?.code);
        onOpenModal2();
      } else {
        window.alert("Invalid Code !");
      }
    }
  };
  const handleRemoveGiftcard = () => {
    setIsGiftCard(false);
    setcoupnDis(0);
    setGiftcardCoupon("");
    localStorage.setItem("giftcard", "");
    localStorage.setItem("zeroprice", "false");
  };
  const handleRedcashChange = (e) => {
    if (!isRedcash) {
      if (myCash["coins"] > 0) {
        setIsRedcash(true);
        removeCoupn();
        handleRemoveGiftcard();
        setcoupnDis(
          Math.min(
            Math.floor((offerSum + deliveryCharges) * 0.25),
            myCash["coins"]
          )
        );
        localStorage.setItem("is_redcash_applied", "true");
        onOpenModal2();
        // setTimeout(() => {
        //   onCloseModal2();
        // }, 1800);
      } else {
        alert("You don't have any available RedCash");
      }
    } else {
      setIsRedcash(false);
      setcoupnDis(0);
      localStorage.setItem("is_redcash_applied", "false");
    }
    console.log(e.target.value);
  };

  /////////////

  useEffect(() => {
    if (coupError === "Invalid Coupon Code") {
      if (coupCode !== "") {
        setCoupError("");
      }
    }
  }, [coupCode]);

  const handleCitySubmit = (e) => {
    localStorage.setItem("city", e.target.value);
    dispatch(setCity(e.target.value));
    e.target.blur();
  };
  const closeCartModal = () => {
    setOpenCartt(false);
  };
  const [giftcardCoupon, setGiftcardCoupon] = useState("");
  //const coupns
  const Coupns = ({ val }) => {
    return (
      <div
        data-tip={
          val.tnc != null && val.tnc != ""
            ? "Terms and Conditions:<br>" + val.tnc.split("\r\n").join("<br>")
            : null
        }
      >
        <div className=" modalCouponsList">
          <img src={giftCard} alt="" />
          &emsp;
          <div className="modalCouponName">
            {val.name}{" "}
            <div onClick={(e) => applyCoupn(val)} className="modalApplyButton">
              Apply
            </div>
          </div>
          {/* <div> ₹ {val.discount}</div> */}
        </div>
        <div className="modalCouponDiscount">
          GET{" "}
          {val.discount_type == "percentage" ? (
            <span>{val.discount}%</span>
          ) : (
            <span>₹ {val.discount}</span>
          )}{" "}
          {val.is_red_cash ? "Cashback" : "Off"}
        </div>

        <ReactTooltip place="bottom" html={true} />
      </div>
    );
  };
  return (
    <div>
      <div className="booking_Razordiv">
        <div className="topRazor">
          <p>
            <span className="textblueBold textblackBold offerprice">
              ₹{details !== "" ? offerSum : offerPrice && offerPrice}
            </span>
            &nbsp;{" "}
            <span className="sellingPrice">
              ₹{details !== "" ? sum : Mrp && Mrp}
            </span>
          </p>
          {/* <span className="btn_neon">Get {discountPercentage}% OFF</span> */}
          <span className="btn_neon btn_neon2">
            Get{" "}
            {details !== ""
              ? discountPercent
              : discountPercentage && discountPercentage}
            % OFF
          </span>
        </div>
        <div className="borderBook" />

        <div className={showDetails ? "toogleBook" : "height0"}>
          {imagine ? null : deliveryCharges && deliveryCharges !== "" ? null : (
            <>
              <div className="priceBreakParent priceBreakParent2">
                <span>Home Collection Charges</span>
                <div className="rightSidediv_booking">
                  {/* <span>₹250</span> */}
                  <span className="textSecondary">FREE</span>
                </div>
                <div className="borderBook" />
              </div>
              <div className="borderBook"></div>
            </>
          )}

          <div className="priceBreakParent pbpMargin">
            <span>Offer Price</span>
            <div>
              {/* <span>₹{packageDetails?.package_price}</span> */}
              {/* <span>₹ {details !== "" ? sum : Mrp && Mrp}</span> */}₹
              {details !== "" ? offerSum : offerPrice && offerPrice}
            </div>
          </div>
          {imagine ? null : packDetail ? null : (
            <div className="priceBreakParent">
              <span>Sample Collection Charges</span>
              <div>
                <span>₹ {deliveryCharges}</span>
              </div>
            </div>
          )}

          <div className="priceBreakParent pbpMargin">
            <span>Discount</span>
            <div>
              <span>
                -₹ {details !== "" ? discountSum : discount && discount}
              </span>
            </div>
          </div>
          {coupnDis > 0 ? (
            <div className="priceBreakParent">
              <span className="coupnSpan">
                {isRedcash ? "Redcash" : isGiftCard ? "Giftcard" : "Coupon"}{" "}
                Applied
              </span>
              <div>
                <span>-₹ {coupnDis}</span>
              </div>
            </div>
          ) : null}

          <div className="borderBook" />
          <div
            className="priceBreakParent  "
            style={{ fontWeight: "600", fontSize: "1.8rem", color: "#gray" }}
          >
            <span>Total Amount</span>
            <div>
              <span>
                ₹{" "}
                {packDetail
                  ? offerPrice
                  : details !== ""
                  ? offerSum + deliveryCharges - coupnDis
                  : finalPrice && finalPrice}
              </span>
            </div>
          </div>
        </div>

        <span className="guidelines">
          *inclusive of all the taxes, fees and subject to availability
        </span>
        <div className="borderBook" />
        <div
          className="price_Break"
          onClick={() => setShowDetails(!showDetails)}
        >
          <span className="textSecondary">
            {" "}
            {showDetails ? "Hide Price Breakup" : "Show Price Breakup"}{" "}
          </span>{" "}
          <FiChevronDown />
        </div>
      </div>

      <div className="booking_Razordiv">
        <p className="textSecondary note">
          YOU SAVED Rs.{" "}
          {details !== ""
            ? discountSum + coupnDis
            : discount && discount + coupnDis}{" "}
          ON THIS BOOKING!
        </p>

        {location.pathname == "/cart" ? (
          <div className={details !== "" ? "coupnCodeDiv" : null}>
            {coupnCode?.results?.some((val) => val.name == active) ? (
              <div className="applyCoupon">
                <div>
                  <div className="couponNameText">
                    <img className="couponDiscountImg" src={Discount} alt="" />
                    &emsp; <span>{active}</span>
                  </div>
                  <div className="offerAppliedText">
                    Offer applied on the bill
                  </div>
                </div>
                <div className="applyCouponExpand">
                  <img src={metroCross} onClick={removeCoupn} alt="" />
                  {/* <AiOutlineRight onClick={onOpenModal} /> */}
                </div>
              </div>
            ) : (
              <div>
                <div
                  onClick={handleClickOpenSlider}
                  className={
                    isRedcash || isGiftCard ? "applyCouponDis" : "applyCoupon"
                  }
                >
                  <div className="applyCouponText">
                    <img src={Discount} alt="" />
                    &emsp; Apply Coupon
                  </div>
                  <div className="applyCouponExpand">
                    <AiOutlineRight />
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : null}
        {/* redcash */}
        {location.pathname == "/cart" ? (
          <div>
            <div className="applyCoupon applyCoupon1">
              <div>
                <div className="redcashText">
                  <div></div>
                  <img className="redcashImg" src={greenWallet} alt="" />
                  &emsp; Pay Via Redcash
                  <div className="redcashCheckbox redcashCheckbox1">
                    <input
                      type="checkbox"
                      checked={isRedcash}
                      onChange={handleRedcashChange}
                      value={isRedcash}
                      style={{ width: "16px", height: "16px" }}
                    />
                  </div>
                </div>
                <div className="redcashBalanceText">
                  Available Redcash Balance &#8377;
                  {myCash ? myCash["coins"] : "loading"}
                </div>
              </div>
            </div>

            <div className={isRedcash ? "applyCouponDis" : "applyCoupon"}>
              <div style={{ width: "100%" }}>
                <div className="redcashText">
                  <img className="giftCardImg" src={giftCardImg} alt="" />
                  &emsp; Pay Via Giftcard
                </div>
                <div className="redcashBalanceText giftcardInput giftcardInput1">
                  <input
                    onChange={(e) => {
                      !isGiftCard ? setGiftcardCoupon(e.target.value) : null;
                    }}
                    style={isGiftCard ? { caretColor: "transparent" } : null}
                    value={giftcardCoupon}
                    placeholder="Enter Giftcard code"
                    type="text"
                  />
                  {isGiftCard ? (
                    <div
                      onClick={handleRemoveGiftcard}
                      style={{ color: "#E5184E", marginLeft: "-50px" }}
                      className="giftcardApply"
                    >
                      Remove
                    </div>
                  ) : (
                    <div
                      onClick={() => {
                        giftcardCoupon.trim() != ""
                          ? handleApplyGiftcard()
                          : null;
                      }}
                      className="giftcardApply"
                    >
                      Apply
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <span
          className="add_tocart "
          style={
            goto !== ""
              ? { display: "flex", width: "100", justifyContent: "center" }
              : { display: "flex", width: "100", justifyContent: "center" }
          }
          onClick={() => {
            NextbUTTON(
              packageDetails && packageDetails.id,
              packageDetails?.slug,
              handleSubmit && handleSubmit,
              details !== "" && details
            );
          }}
        >
          {cartButton}
          <span> {goto}</span>
        </span>
      </div>

      <Modal
        classNames={{ overlay: "customOverlay2", modal: "customModal2" }}
        open={open2}
        onClose={onCloseModal2}
        center
      >
        <div className="modal2">
          <div className="discountImgModal2">
            <img src={Discount} alt="" />
          </div>
          <div className="coupnAppliedModal2">
            <span className="coupnNameModal2">
              {isRedcash ? (
                "Redcash"
              ) : isGiftCard ? (
                "Giftcard"
              ) : (
                <span>'{active}'</span>
              )}
            </span>
            <span className="modal2appliedText">&nbsp;applied</span>
          </div>
          <div className="modal2Discount">
            ₹{isGiftCard ? coupnDis : cashback != 0 ? cashback : coupnDis}
          </div>
          <div className="modal2savings">
            {isGiftCard
              ? "paid"
              : cashback != 0
              ? cashback != 0 && coupnDis != 0
                ? "cashback and"
                : "cashback with "
              : "savings with "}
            {isGiftCard
              ? "giftcard"
              : cashback != 0 && coupnDis != 0
              ? ""
              : "this coupon"}
          </div>
          <div className="modal2Discount">
            {cashback != 0 && coupnDis != 0 ? "₹" + coupnDis : null}
          </div>
          <div className="modal2savings">
            {cashback != 0 && coupnDis != 0
              ? "discount with this coupon"
              : null}
          </div>
          {/* <div className="modal2filler">{active} and save on your order</div> */}
        </div>
      </Modal>
      <Modal
        open={openCartt}
        onClose={onCloseModalCartt}
        center
        classNames={{
          modal: "selectedCityForPackage selectedCityForPackageInCart",
        }}
      >
        <div className="packageDrop">
          <hr className="topHr" />
          <div className="citySelectHome">
            <form>
              <input
                onFocus={(e) => {
                  e.target.select(), setDisplay(true);
                }}
                style={{ width: "90px" }}
                className="cityDrop_model cityDrop_modelInCart"
                value={searchCity.replace("_", " ")}
                onChange={(e) => {
                  setSearchCity(e.target.value.replace(" ", "_")),
                    setDisplay(true);
                }}
                placeholder="search city"
              />
            </form>
            {display ? (
              <div className="divCity divCityInCart" defaultValue="Noida">
                <span
                  onClick={() => {
                    setDisplay(false);
                    setSearchCity("");
                    handelCity("");
                    onCloseModalCartt();
                  }}
                  value=""
                >
                  Select City
                </span>
                {navCity && navCity.navCities && navCity.navCities.cities ? (
                  navCity.navCities.cities
                    .filter((city, index) => {
                      if (searchCity == "") {
                        return city;
                      } else if (
                        city.toLowerCase().includes(searchCity.toLowerCase())
                      ) {
                        return city;
                      }
                    })
                    .map((ele, index) => {
                      return (
                        <span
                          onClick={() => handelCity(ele)}
                          key={index}
                          selected={ele == citySelected.citySelect}
                          value={ele}
                        >
                          {ele.replace("_", " ")}
                        </span>
                      );
                    })
                ) : (
                  <Loader />
                )}
              </div>
            ) : null}
          </div>
          {/* <hr className="bottomHr" /> */}
          {/* <div className="cartButtons">
            <button className="closeModal" onClick={() => closeCartModal()}>
              Close
            </button>
          </div> */}
        </div>
      </Modal>
      <SlidingPane
        className="couponSlider"
        overlayClassName="couponSliderOverlay"
        isOpen={state.isPaneOpen}
        hideHeader
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          setState({ isPaneOpen: false });
        }}
      >
        <div
          onClick={() => setState({ isPaneOpen: false })}
          className="modalCrossButton"
        >
          <img className="crossImage" src={metroCross} alt="" />
        </div>
        <div className="sliderBox">
          <div className="applyCouponInnerBlock applyCouponText">
            Apply Coupon
          </div>
          <div className="applyCouponInnerBlock ">
            <div className="modalInput">
              <input
                className="modalTextInput"
                type="text"
                value={coupCode}
                onChange={handleCoupCode}
                placeholder="Enter Coupon Code"
              />
              <div className="modalApplyButton">
                <div
                  onClick={handleApplyCoupon}
                  className="modalApplyButton_inner_div"
                >
                  Search
                </div>
              </div>
            </div>
            {coupError != "" ? (
              <div className="couponCodeError">{coupError}</div>
            ) : null}
          </div>
          {coupnCode?.count === 0 ? (
            <div className="applyCouponInnerBlock modalSelectCoupon">
              No Coupons Available
            </div>
          ) : (
            <div className="applyCouponInnerBlock modalSelectCoupon">
              Select coupons from the list
            </div>
          )}

          {details !== "" && couponLoading ? (
            <Loader />
          ) : (
            coupnCode &&
            coupnCode &&
            coupnCode?.results?.map((val) => {
              if (
                val.is_active &&
                val.minimum_price < offerSum + deliveryCharges &&
                val.org_type == "homedx"
              ) {
                if (val.packages?.length > 0) {
                  if (val.packages?.some((x) => ItemidInCart.includes(x.id))) {
                    return <Coupns val={val} />;
                  } else {
                    return null;
                  }
                } else {
                  return <Coupns val={val} />;
                }
              } else {
                return null;
              }
            })
          )}
        </div>
      </SlidingPane>
    </div>
  );
}

const mapStateToProps = (state) => ({
  Redcash: state?.getRedcashReducer,
  CartItem: state?.CartReducer?.cartDetails,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setAllAddonTrue: () => {
      dispatch(setAllPackageAddonTrue());
    },
    setAllAddonFalse: () => {
      dispatch(setAllPackageAddonFalse());
    },
    getCoupon: (token, code) => {
      dispatch(getCouponCode(token, code));
    },
    getRedcash: (token) => {
      dispatch(getRedcash(token));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(BookForm));
